
import { Vue, Component, Prop } from "vue-property-decorator";

import GET_CUSTOM_REQUESTS from "@/apollo/requests/GetCustomRequests.gql";

import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import ProjectActivityForm from "@/entities/ProjectActivityForm";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import Roles from "@/entities/Roles";
import ProjectCustomRequest from "@/components/projects/ProjectCustomRequestNew.vue";
import { Project } from "@/generated/graphql";
import { getNextOffset } from "@/helpers/pagination";
import { getProjectCustomRequestConditions } from "@/helpers/queryConditions/customRequests";
import CustomRequestCard from "@/components/requests/CustomRequestCardNew.vue";
import EmptyListImageRequests from "@/components/icons/emptyListImages/EmptyListImageRequests.vue";

@Component({
  components: {
    EmptyListImageRequests,
    CustomRequestCard,
    ProjectCustomRequest,
    EmptyListPlaceholder,
    CardPagination,
    LoadingOverlay,
  },
  apollo: {
    requestsData: {
      query: GET_CUSTOM_REQUESTS,
      variables() {
        return {
          offset: getNextOffset(this.paginationConfig),
          limit: this.paginationConfig.limit,
          where: getProjectCustomRequestConditions(this.project.id),
        };
      },
      update({ requests, requestsTotal }) {
        this.paginationConfig.total = requestsTotal.aggregate.count;
        this.requests = requests;
      },
    },
  },
})
export default class Requests extends Vue {
  @Prop({ type: Object, required: true }) readonly project!: Project;
  @Prop({ type: String, required: true }) readonly userRole!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;

  requests: ProjectActivityForm[] | null = null;
  paginationConfig: PaginationConfig = { ...paginationConfig };

  get emptyListSubtitle(): string {
    if (this.isAdmin) {
      return "";
    }

    return "Create a request if you cannot find a suitable contractor for your job";
  }

  get hasData(): boolean {
    return Boolean(this.requests);
  }

  get isListEmpty(): boolean {
    if (!this.requests) {
      return false;
    }

    return this.requests.length === 0;
  }

  get isAdmin(): boolean {
    return this.userRole === Roles.ADMIN;
  }

  get ableToCreateCustomRequest(): boolean {
    return !this.project.completed && !this.isAdmin;
  }

  get isLoading(): boolean {
    return this.$apollo.queries.requestsData.loading;
  }

  get isActivitiesLoaded(): boolean {
    return this.isLoading && !this.requests;
  }

  refetch(): void {
    this.$apollo.queries.requestsData.refetch();
  }
}
